export const getHouseTitle = (housesNames: string[]): string => {
  if (!housesNames.length) {
    return '';
  }

  const houseTitle = housesNames.length === 1 ? 'корпус:' : 'корпуса:';
  const housesNamesString = housesNames.join(', ');

  return `${houseTitle} ${housesNamesString}`;
};
